import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const Deposit = () => {
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(true);
  const [deposits, setDeposits] = useState([]);
  const [banks, setBanks] = useState([]);
  const [balance, setBalance] = useState(0);
  const [balance2, setBalance2] = useState(0);
  const [qrCode, setQrCode] = useState('');
  const [upi,setUpi] = useState('');
  
  // Modal states
  const [depositModal, setDepositModal] = useState(false);
  const [upiModal, setUpiModal] = useState(false);
  const [bankDetailModal, setBankDetailModal] = useState(false);
  
  // Form states
  const [depositAmount, setDepositAmount] = useState('');
  const [depositRemarks, setDepositRemarks] = useState('');
  
  // Selected bank details
  const [selectedBank, setSelectedBank] = useState({
    acc_name: '',
    acc_number: '',
    acc_type: '',
    ifsc_code: '',
    bank_name: ''
  });

  // Check if user is logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('LoggedIn');
    if (!isLoggedIn || isLoggedIn !== '1') {
      toast.error('Please login first');
      navigate('/login');
      return;
    }
    
    loadData();
  }, [navigate]);

  const loadData = async () => {
    try {
      const userid = localStorage.getItem('userid');
      if (!userid) {
        toast.error('User ID not found');
        navigate('/login');
        return;
      }

      // Fetch balance and QR code
      const balanceUrl = `https://octafxx.in/Rest/home_wallet_api/${userid}`;
      const balanceResponse = await fetch(balanceUrl);
      const balanceData = await balanceResponse.json();
      setBalance(balanceData.bal || 0);
      setBalance2(balanceData.bal2 || 0);
      setQrCode(balanceData.qr_code || '');
      setUpi(balanceData.upi || '');

      // Fetch banks list
      const banksUrl = 'https://octafxx.in/Rest/banks_api';
      const banksResponse = await fetch(banksUrl);
      const banksData = await banksResponse.json();
      setBanks(banksData);

      // Fetch deposits history
      await fetchDeposits(userid);
      
      setSpinner(false);
    } catch (error) {
      console.error('Error loading data:', error);
      toast.error('Failed to load data');
      setSpinner(false);
    }
  };

  const fetchDeposits = async (userid) => {
    try {
      const url = `https://octafxx.in/Rest/deposite_api/${userid}`;
      const response = await fetch(url);
      const data = await response.json();
      setDeposits(data);
    } catch (error) {
      console.error('Error fetching deposits:', error);
      toast.error('Failed to load deposit history');
    }
  };

  const handleDepositSubmit = async (e) => {
    e?.preventDefault();
    
    if (!depositAmount) {
      toast.error('Please enter deposit amount');
      return;
    }

    if (parseFloat(depositAmount) <= 0) {
      toast.error('Please enter a valid amount');
      return;
    }

    setSpinner(true);
    
    try {
      const userid = localStorage.getItem('userid');
      
      const formData = new FormData();
      formData.append('depo_amt', depositAmount);
      formData.append('depo_remarks', depositRemarks);

      const response = await fetch(`https://octafxx.in/Rest/web_deposite_submit_api/${userid}`, {
        method: 'POST',
        body: formData
      });

      const responseData = await response.json();
      
      if (responseData.status === 0) {
        toast.success(responseData.msg || 'Deposit request submitted successfully');
        setDepositModal(false);
        setDepositAmount('');
        setDepositRemarks('');
        
        // Refresh deposits list
        await fetchDeposits(userid);
      } else {
        toast.error(responseData.msg || 'Failed to submit deposit request');
      }
    } catch (error) {
      console.error('Deposit submission error:', error);
      toast.error('Network error. Please try again.');
    } finally {
      setSpinner(false);
    }
  };

  const showBankDetails = (bank) => {
    setSelectedBank({
      acc_name: bank.acc_name || '',
      acc_number: bank.acc_number || '',
      ifsc_code: bank.ifsc_code || '',
      acc_type: bank.acc_type || '',
      bank_name: bank.bank_name || ''
    });
    setBankDetailModal(true);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        toast.success('Copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy:', err);
        toast.error('Failed to copy');
      });
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending': return 'warning';
      case 'approved': return 'success';
      case 'rejected':
      case 'reject': return 'danger';
      default: return 'secondary';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch (error) {
      return dateString;
    }
  };

  if (spinner && banks.length === 0) {
    return (
      <div className="container-fluid bg-light min-vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading deposit information...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid bg-light min-vh-100">
      <ToastContainer position="top-right" autoClose={3000} />
      
      {/* UPI QR Code Modal */}
      {upiModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-dark">UPI Payment QR Code</h5>
                <button 
                  type="button" 
                  className="btn-close text-danger"
                  onClick={() => setUpiModal(false)}
                >X</button>
              </div>
              <div className="modal-body text-center">
                {qrCode ? (
                  <div>
                    <img 
                      src={`https://octafxx.in/eassets/${qrCode}`}
                      alt="UPI QR Code"
                      className="img-fluid rounded"
                      style={{ maxHeight: '400px' }}
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/300x300/1a5276/ffffff?text=QR+Code+Not+Found';
                      }}
                    />
                    
                    <div className="mt-3">
                      <p className="text-muted">Scan this QR code with any UPI app to make payment</p>
                    </div>
                  </div>
                ) : (
                  <div className="alert alert-warning">
                    <i className="bi bi-exclamation-triangle me-2"></i>
                    QR Code not available
                  </div>
                )}

                {upi ? (
                  <div className="alert alert-info mt-3 d-flex justify-content-between align-items-center">
                    <span>
                      <i className="bi bi-credit-card me-2"></i>
                      <strong>UPI ID:</strong> {upi}
                    </span>
                    <button 
                      className="btn btn-sm btn-primary"
                      onClick={() => copyToClipboard(upi)}
                    >
                      <i className="bi bi-copy me-1"></i>
                      Copy UPI
                    </button>
                  </div>
                ) : (
                  <div className="alert alert-warning mt-3">
                    <i className="bi bi-exclamation-triangle me-2"></i>
                    UPI ID not available
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bank Details Modal */}
      {bankDetailModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content bg-gradient bg-primary text-white">
              <div className="modal-header border-0">
                <h5 className="modal-title">{selectedBank.bank_name}</h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white"
                  onClick={() => setBankDetailModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-8">
                    <span className="opacity-75">Account Name</span>
                  </div>
                  <div className="col-4 text-end">
                    <span className="fw-bold">{selectedBank.acc_name}</span>
                    <button 
                      className="btn btn-link text-white p-0 ms-2"
                      onClick={() => copyToClipboard(selectedBank.acc_name)}
                    >
                      <i className="bi bi-copy"></i>
                    </button>
                  </div>
                </div>
                
                <div className="row mb-3">
                  <div className="col-8">
                    <span className="opacity-75">Account Number</span>
                  </div>
                  <div className="col-4 text-end">
                    <span className="fw-bold">{selectedBank.acc_number}</span>
                    <button 
                      className="btn btn-link text-white p-0 ms-2"
                      onClick={() => copyToClipboard(selectedBank.acc_number)}
                    >
                      <i className="bi bi-copy"></i>
                    </button>
                  </div>
                </div>
                
                <div className="row mb-3">
                  <div className="col-8">
                    <span className="opacity-75">IFSC Code</span>
                  </div>
                  <div className="col-4 text-end">
                    <span className="fw-bold">{selectedBank.ifsc_code}</span>
                    <button 
                      className="btn btn-link text-white p-0 ms-2"
                      onClick={() => copyToClipboard(selectedBank.ifsc_code)}
                    >
                      <i className="bi bi-copy"></i>
                    </button>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-8">
                    <span className="opacity-75">Account Type</span>
                  </div>
                  <div className="col-4 text-end">
                    <span className="fw-bold">{selectedBank.acc_type}</span>
                    <button 
                      className="btn btn-link text-white p-0 ms-2"
                      onClick={() => copyToClipboard(selectedBank.acc_type)}
                    >
                      <i className="bi bi-copy"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <button 
                  type="button" 
                  className="btn btn-light"
                  onClick={() => setBankDetailModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Deposit Request Modal */}
      {depositModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">New Deposit Request</h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white"
                  onClick={() => setDepositModal(false)}
                ></button>
              </div>
              <form onSubmit={handleDepositSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label htmlFor="depositAmount" className="form-label text-dark">
                      Deposit Amount <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-lg"
                      id="depositAmount"
                      placeholder="Enter amount"
                      value={depositAmount}
                      onChange={(e) => setDepositAmount(e.target.value)}
                      min="1"
                      required
                    />
                    <div className="form-text">Minimum deposit amount: 100</div>
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="depositRemarks" className="form-label text-dark">
                      Remarks (Optional)
                    </label>
                    <textarea
                      className="form-control"
                      id="depositRemarks"
                      placeholder="Add any remarks or transaction ID"
                      rows="3"
                      value={depositRemarks}
                      onChange={(e) => setDepositRemarks(e.target.value)}
                    ></textarea>
                  </div>
                  
                  <div className="alert alert-info">
                    <i className="bi bi-info-circle me-2"></i>
                    Please transfer the amount to any of our bank accounts listed below and submit this request.
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    type="button" 
                    className="btn btn-secondary"
                    onClick={() => setDepositModal(false)}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-primary"
                    disabled={spinner}
                  >
                    {spinner ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Submitting...
                      </>
                    ) : (
                      'Submit Request'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow">
        <div className="container-fluid">
          <div className="d-flex align-items-center">
            <button 
              className="btn btn-link text-white me-2"
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-arrow-left fs-4"></i>
            </button>
            <h1 className="navbar-brand mb-0 h1 fs-4">Deposit Funds</h1>
          </div>
          <div>
            <button 
              className="btn btn-outline-light btn-sm"
              onClick={() => navigate('/withdraw')}
            >
              <i className="bi bi-arrow-up-circle me-1"></i>
              Withdraw
            </button>
          </div>
        </div>
      </nav>

      <div className="container py-4">
        {/* Balance Card */}
        <div className="card bg-primary text-white shadow-lg mb-4 border-0">
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="mb-3">
                  <small className="opacity-75">Available Balance</small>
                  <h2 className="fw-bold mb-0">${parseFloat(balance).toFixed(2)}</h2>
                  <small>₹{balance2}</small>
                </div>
              </div>
              <div className="col-md-6 text-md-end">
                <button 
                  className="btn btn-light btn-lg"
                  onClick={() => setDepositModal(true)}
                >
                  <i className="bi bi-plus-circle me-2"></i>
                  New Deposit
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Banks List */}
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header bg-white border-0">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0 fw-bold">
                <i className="bi bi-bank me-2"></i>
                Our Bank Accounts
              </h5>
              <button 
                className="btn btn-outline-primary btn-sm"
                onClick={() => setUpiModal(true)}
              >
                <i className="bi bi-qr-code-scan me-1"></i>
                UPI Payment
              </button>
            </div>
          </div>
          <div className="card-body">
            {banks.length === 0 ? (
              <div className="text-center py-3">
                <p className="text-muted">No bank accounts available</p>
              </div>
            ) : (
              <div className="row g-3">
                {banks.map((bank, index) => (
                  <div key={index} className="col-md-6">
                    <div className="card border-0 bg-gradient bg-danger text-white">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 className="card-title mb-1 fw-bold">
                              {bank.bank_name?.substring(0, 25) || 'Bank Account'}
                              {bank.bank_name?.length > 25 && '...'}
                            </h6>
                            <small className="opacity-75">Click details to view account information</small>
                          </div>
                          <button 
                            className="btn btn-light btn-sm"
                            onClick={() => showBankDetails(bank)}
                          >
                            <i className="bi bi-eye me-1"></i>
                            Details
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Deposit History */}
        <div className="card shadow-sm border-0">
          <div className="card-header bg-white border-0">
            <h5 className="card-title mb-0 fw-bold">
              <i className="bi bi-clock-history me-2"></i>
              Deposit History
            </h5>
          </div>
          <div className="card-body">
            {deposits.length === 0 ? (
              <div className="text-center py-5">
                <i className="bi bi-wallet display-1 text-muted mb-3"></i>
                <h5 className="text-muted">No Deposit History</h5>
                <p className="text-muted">Your deposit requests will appear here</p>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Remarks</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deposits.map((deposit, index) => (
                        <tr key={index}>
                          <td>{formatDate(deposit.dep_submit_date)}</td>
                          <td className="fw-bold">{parseFloat(deposit.dep_amt || 0).toFixed(2)}</td>
                          <td>
                            {deposit.dep_remarks || (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            <span className={`badge bg-${getStatusColor(deposit.dep_status)}`}>
                              {deposit.dep_status || 'N/A'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="text-muted small">
                    Showing {deposits.length} deposit requests
                  </div>
                  <button 
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => loadData()}
                  >
                    <i className="bi bi-arrow-clockwise me-1"></i>
                    Refresh
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Information Section */}
        <div className="row mt-4">
          <div className="col-md-6">
            <div className="card bg-light border-0">
              <div className="card-body">
                <h6 className="card-title fw-bold">
                  <i className="bi bi-info-circle text-primary me-2"></i>
                  Deposit Instructions
                </h6>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="bi bi-check-circle text-success me-2"></i>
                    Transfer amount to any bank account from the list
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle text-success me-2"></i>
                    Keep transaction ID or UTR number for reference
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle text-success me-2"></i>
                    Submit deposit request with exact amount
                  </li>
                  <li>
                    <i className="bi bi-check-circle text-success me-2"></i>
                    Funds will be credited within 1-2 hours after verification
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="card bg-light border-0">
              <div className="card-body">
                <h6 className="card-title fw-bold">
                  <i className="bi bi-shield-check text-primary me-2"></i>
                  Important Notes
                </h6>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    Minimum deposit amount is 100
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    Use same name as registered account for transfer
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    Contact support if deposit not credited within 24 hours
                  </li>
                  <li>
                    <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                    False deposit claims may lead to account suspension
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-dark text-white py-3 mt-4">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <small className="opacity-75">© {new Date().getFullYear()} Secure Deposit System</small>
            </div>
            <div className="col-md-6 text-md-end">
              <small className="opacity-75">
                <i className="bi bi-headset me-1"></i>
                Support: support@octafxx.in 
              </small>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Deposit;